import { toJS } from 'utils/immutableUtils';

const View = {
  StartPage: {
    title: 'iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  NewDishesView: {
    title: 'New Dishes - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  ExcludedDishesView: {
    title: 'Excluded Dishes - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  NewIngredientsView: {
    title: 'New Ingredients - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  NewGlobalDishes: {
    title: 'New Global Dishes - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  ExcludedIngredientsView: {
    title: 'Excluded Ingredients - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  NewGlobalIngredients: {
    title: 'New Global Ingredients - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiListDraft: {
    name: 'PPSI_DRAFT',
    title: 'Draft Dish Instructions - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiListApproved: {
    name: 'PPSI_APPROVED',
    title: 'Scheduled Dish Instructions - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiListPublished: {
    name: 'PPSI_PUBLISHED',
    title: 'Published Dish Instructions - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiPublishedListGlobalNirView: {
    // NIR Only view
    name: 'PPSI_PUBLISHED_GLOBAL_NIR',
    title: "Global Published PPSI's - iFoodPPSI",
    visit() {
      document.title = this.title;
    }
  },
  PpsiCreateFromGlobalNirView: {
    // NIR Only view
    visit(ingredient) {
      const { presentationName, itemCode } = ingredient;
      document.title = `Create Instruction ${presentationName} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpsiListGlobalApprovalStatus: {
    name: 'PPSI_Approval_Status',
    title: 'Approval Status - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiCreate: {
    visit(dish, language) {
      const { presentationName, itemCode } = dish;
      document.title = `Create Instruction ${presentationName[language]} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpsiCreateVariant: {
    visit(dish, language) {
      const { presentationName, itemCode } = dish;
      document.title = `Create Variant ${presentationName[language]} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpsiCreateFromExisting: {
    visit(dish) {
      const { presentationName, itemCode } = dish;
      document.title = `Create Instruction ${presentationName} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpsiEdit: {
    name: 'PPSI_EDIT',
    visit(ppsi, language) {
      document.title = `${ppsi.inProgressPpsiEnrichmentData.info[language].presentationName} (${ppsi.formulaCode}) - iFoodPPSI`;
    }
  },
  PpsiPublished: {
    visit(ppsi, language) {
      document.title = `${ppsi.publishedPpsiEnrichmentData.info[language].presentationName} (${ppsi.formulaCode}) - iFoodPPSI - Crafted with love`;
    }
  },
  GlobalApproval: {
    visit(ppsi, language) {
      document.title = `${ppsi.inProgressPpsiEnrichmentData.info[language].presentationName} (${ppsi.formulaCode}) - iFoodPPSI`;
    }
  },
  PpiListDraft: {
    title: 'Draft Ingredient Instructions - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpiListPublished: {
    title: 'Published Ingredient Instructions - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpiCreate: {
    visit(ingredient, currLanguage) {
      const { presentationName, itemCode } = ingredient;
      document.title = `Create Instruction ${presentationName[currLanguage]} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpiCreateVariant: {
    visit(dish, language, itemCode) {
      const { info } = dish;
      document.title = `Create Variant ${info[language].presentationNam} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpiCreateFromExisting: {
    visit(ingredient) {
      const { presentationName, itemCode } = ingredient;
      document.title = `Create Instruction ${presentationName} (${itemCode}) - iFoodPPSI`;
    }
  },
  PpiCreateFromExistingSelectPpi: {
    title: 'Select Ingredient Instruction to Copy',
    visit() {
      document.title = this.title;
    }
  },
  PpsiCreateFromExistingSelectPpsi: {
    title: 'Select Dish Instruction to Copy',
    visit() {
      document.title = this.title;
    }
  },
  PpiEdit: {
    visit(ppi, language) {
      const { inProgressPPIEnrichmentData } = ppi;
      document.title = `${inProgressPPIEnrichmentData.info[language].presentationName} - iFoodPPSI`;
    }
  },
  PpiPublished: {
    visit(ppi, language) {
      const { publishedPPIEnrichmentData } = ppi;
      document.title = `${publishedPPIEnrichmentData.info[language].presentationName} - iFoodPPSI`;
    }
  },
  UpdatesList: {
    title: 'Updates',
    visit() {
      document.title = this.title;
    }
  },
  UnpublishedPpsis: {
    name: 'PPSI_UNPUBLISHED',
    title: 'Unpublished Dish Data - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  UnpublishedPpi: {
    name: 'PPI_UNPUBLISHED',
    title: 'Unpublished Ingredient Data - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  ReviewWaitingSummary: {
    title: 'Waiting For Review - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiReportView: {
    title: 'Reports - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  PpsiTotalRangeDish: {
    title: 'Total Range Dish Statistics - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  ReviewWaitingMarketSummary: {
    title: 'Waiting For Review - iFoodPPSI',
    visit() {
      document.title = this.title;
    }
  },
  NotFound404: {
    title: '',
    visit() {
      document.title = this.title;
    }
  },
  Search: {
    title: 'Search',
    visit() {
      document.title = this.title;
    }
  },
  MarketSetting: {
    title: 'Market Setting',
    visit() {
      document.title = this.title;
    }
  },
  UploadBomReportView: {
    title: 'Upload Bom Report',
    visit() {
      document.title = this.title;
    }
  }
};

export default View;
